import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { useIsMobile } from '@scramble/hooks';
import { useGetHappyBrands } from '@/query/queries/dashboard/useGetHappyBrands';
import { useModal } from '@/providers/modal';
import { MODAL_IDS } from '@/kit/Modal/keys';
import { Image } from '@/components/Image';
import { HappyBrandsModal } from './modal';
import s from './index.module.scss';

export const HappyBrands = () => {
  const { t } = useTranslation();
  const { data } = useGetHappyBrands();
  const isMobile = useIsMobile();
  const { openModal } = useModal();
  const hasBrands = !!data?.total;

  const onClick = () => {
    hasBrands && openModal(MODAL_IDS.happy_brands);
  };

  if (!data) return null;

  return (
    <>
      <div className={classnames(s.wrapper, hasBrands && "brands")} onClick={onClick}>
        <div className="f-body-md f-500">
          {t('dashboard:happy_brands.helped_brands', {
            count: data.total_brands,
          })}
        </div>
        <div className={s.brands}>
          {data?.founders.slice(0, isMobile ? 3 : 5).map(brand => (
            <div key={brand.id} className={s.photo}>
              <Image
                image={brand.url_logo}
                preset="companyLogoCompact"
                alt={brand.url_logo?.name}
                width={40}
                height={40}
              />
            </div>
          ))}
        </div>
      </div>
      <HappyBrandsModal />
    </>
  );
};
